export const DATA_GRID_ACTION_COLUMN_NAME = "actions";

export enum GenericListColumnAlignment {
  Left = 10,
  Center = 20,
  Right = 30
}

export enum GenericListSortingDirection {
  Ascending = 10,
  Descending = 20
}

export type TDataGridColumn = {
  field: string;
  columnWidth: number;
  columnVisibility: boolean;
  sortOrder: number;
  alignment: GenericListColumnAlignment;
  showMore: boolean;
};

export type TDataGridSettings = {
  columns: TDataGridColumn[];
  pageSize?: number;
  sortColumnId: string;
  sortDirection: GenericListSortingDirection;
  pinnedColumns: { left: string[]; right: string[] };
};
